const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@components
const RetailLoanNotAvailable = require('../contractRetailLoan/retailLoanNotAvailable/retailLoanNotAvailable');
const RetailLoanWizard = require('../contractRetailLoan/retailLoanWizard/retailLoanWizard');
const RetailLoanSuccess = require('../contractRetailLoan/retailLoanSuccess/retailLoanSuccess');

// @constants
const { BLOCKED_ACCOUNTS_RETAIL_LOAN } = require('constants/operationCodesAccounts');

//@utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
// @utilities
const { getFilteredAccountIndexes } = require('../../../loansUtilities/loansHelper');

class ContractRetailLoan extends React.Component {

    componentWillMount() {
        const {
            getBlockedAccounts,
            immAccounts
        } = this.props;

        if (!immAccounts.get('blockedAccountsSuccess')) {
            const accounts = getFilteredAccountIndexes(immAccounts).map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, BLOCKED_ACCOUNTS_RETAIL_LOAN);
        }
    }

    componentWillUnmount() {
        const { reset, resetBlockedAccounts, segmentedLoanProductsReset } = this.props;
        reset();
        segmentedLoanProductsReset();
        resetBlockedAccounts();
    }

    buildSuccess() {
        const { immProfile, immRetailLoan } = this.props;
        const defaultEmail = PersonalDataHelper.getEmail(immProfile);
        const email = immRetailLoan.get('newEmail') || defaultEmail;

        return (
            <RetailLoanSuccess
                defaultEmail={defaultEmail}
                email={email}
                immRetailLoan={immRetailLoan}
                immProfile={immProfile}
            />
        );
    }

    render() {
        const {
            changeBillingAddress,
            changeDeliveryAddressValue,
            downloadPreContractDocument,
            downloanRetailLoanContractDocument,
            downloadINEDocument,
            formalize,
            formHandlers,
            getAsnefValidation,
            getHiringDocuments,
            getInfoDestinationAccount,
            getProposition,
            immAccounts,
            immFlagBasedFeatures,
            immProfile,
            immRetailLoan,
            onDownloadDocument,
            onPrintDocument,
            processRequestConfiguration,
            resetAgreeThirdStep,
            setAgreeThirdStep,
            setEmail,
            setRetailLoanAccountsInactive,
            setSelectedAccount,
            setTerm,
            setVisibleStep,
            updatePersonalData,
            validateStep,
            checkReadDocument,
            checkCheckedDocument
        } = this.props;

        let content;
        const purpose = immRetailLoan.get('purpose');
        const success = immRetailLoan.get('success');
        const hasPurpose = purpose !== '';
        const retailLoanNotAvailable = immRetailLoan.get('isNotAvailable');
        const successView = this.buildSuccess();
        const showsInfoProduct = immRetailLoan.get('showInfoProduct');

        if (retailLoanNotAvailable) {
            content = <RetailLoanNotAvailable />;
        } else if (success) {
            content = successView;
        } else if (hasPurpose && !showsInfoProduct) {
            content = (
                <RetailLoanWizard
                    changeBillingAddress={changeBillingAddress}
                    changeDeliveryAddressValue={changeDeliveryAddressValue}
                    downloadPreContractDocument={downloadPreContractDocument}
                    downloanRetailLoanContractDocument={downloanRetailLoanContractDocument}
                    downloadINEDocument={downloadINEDocument}
                    formalize={formalize}
                    formHandlers={formHandlers}
                    getAsnefValidation={getAsnefValidation}
                    getHiringDocuments={getHiringDocuments}
                    getInfoDestinationAccount={getInfoDestinationAccount}
                    getProposition={getProposition}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immProfile={immProfile}
                    immRetailLoan={immRetailLoan}
                    onDownloadDocument={onDownloadDocument}
                    onPrintDocument={onPrintDocument}
                    processRequestConfiguration={processRequestConfiguration}
                    resetAgreeThirdStep={resetAgreeThirdStep}
                    setAgree={setAgreeThirdStep}
                    setEmail={setEmail}
                    setRetailLoanAccountsInactive={setRetailLoanAccountsInactive}
                    setSelectedAccount={setSelectedAccount}
                    setTerm={setTerm}
                    setVisibleStep={setVisibleStep}
                    updatePersonalData={updatePersonalData}
                    validateStep={validateStep}
                    checkReadDocument={checkReadDocument}
                    checkCheckedDocument={checkCheckedDocument}
                />
            );
        }
        return content;
    }
}

ContractRetailLoan.propTypes = {
    changeBillingAddress: PropTypes.func.isRequired,
    changeDeliveryAddressValue: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanRetailLoanContractDocument: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    formHandlers: PropTypes.object.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInfoDestinationAccount: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immSegmented: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    processRequestConfiguration: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetAgreeThirdStep: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetLoanPorpuse: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    setAgreeThirdStep: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setRetailLoanAccountsInactive: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setTerm: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    showInfoProduct: PropTypes.func.isRequired,
    updatePersonalData: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports = ContractRetailLoan
